<template>
  <div class="docs-modern">
    <NavBar />

    <div class="doc-container">
      <!-- Topo -->
      <div class="doc-header">
        <div class="header-content">
          <div class="back-button-section">
            <v-btn class="btn-return" @click="handleToBack">
              <i class="fas fa-arrow-left mr-2"></i>
              Voltar
            </v-btn>
          </div>

          <div class="title-section">
            <h1 class="page-title">
              <i class="fas fa-folder-open title-icon"></i>
              {{ folder.name ? folder.name : "PASTA" }}
            </h1>

            <p class="page-subtitle">Gerencie arquivos dessa pasta.</p>
          </div>

          <div class="actions-section">
            <v-btn class="btn-add-modern" @click="$bvModal.show('createDoc')">
              <i class="fas fa-plus mr-2"></i>
              Novo Arquivo
            </v-btn>
          </div>
        </div>

        <div class="w-50 mx-auto">
          <ErrorsMessages :errors="errors" />
        </div>
      </div>

      <div class="filters-section">
        <div class="filters-card">
          <div class="filter-group">
            <label class="filter-label">
              <i class="fas fa-file filter-icon"></i>
              Filtrar por documentos arquivados
            </label>

            <v-select
              v-model="filterArchivedDocs"
              :items="[
                { text: 'Sim', value: 1 },
                { text: 'Não', value: 0 },
              ]"
              item-text="text"
              item-value="value"
              outlined
              @change="getDocs"
            >
            </v-select>
          </div>

          <div class="filter-group">
            <label class="filter-label">
              <i class="fas fa-file filter-icon"></i>
              Filtrar por documentos lidos
            </label>

            <v-select
              v-model="filterRequiredRead"
              :items="[
                { text: 'Sim', value: 1 },
                { text: 'Não', value: 0 },
              ]"
              item-text="text"
              item-value="value"
              outlined
              @change="getDocs"
            >
            </v-select>
          </div>
        </div>
      </div>

      <div class="container-modern">
        <div class="table-section">
          <div class="table-card">
            <b-overlay :show="loading" opacity="0.99" class="loading-overlay">
              <v-data-table
                :headers="headers"
                :items="docs"
                item-key="id"
                :footer-props="{
                  'items-per-page-options': [10, 50, 100],
                  'items-per-page-text': 'Mostrar',
                }"
                class="modern-table"
                :no-data-text="'Nenhum documento encontrado'"
                :loading="loading"
                :loading-text="'Carregando documentos...'"
              >
                <template v-slot:[`item.archives`]="{ item }">
                  <span
                    class="status-badge"
                    :class="
                      item.archive == 1 ? 'status-inactive' : 'status-active'
                    "
                  >
                    {{ item.archive == 1 ? "Arquivado" : "Não arquivado" }}
                  </span>
                </template>

                <template v-slot:[`item.user_name`]="{ item }">
                  <div class="user-cell">
                    <div class="user-avatar">
                      <img
                        v-if="item.user_photo_url"
                        :src="item.user_photo_url"
                        :alt="item.user_name"
                        class="user-photo"
                      />
                      <i v-else class="fas fa-user"></i>
                    </div>
                    <span class="user-name">{{ item.user_name }}</span>
                  </div>
                </template>

                <template v-slot:[`item.name`]="{ item }">
                  <span class="doc-name">{{ item.name }}</span>
                </template>

                <template v-slot:[`item.type_doc`]="{ item }">
                  <span class="doc-type">{{ item.type_doc }}</span>
                </template>

                <template v-slot:[`item.archive`]="{ item }">
                  <confirmation-dialog
                    small
                    messageTitle=""
                    :message-body="
                      item.archive == 1
                        ? 'Tem certeza que deseja desarquivar o documento?'
                        : 'Tem certeza que deseja arquivar o documento?'
                    "
                    :open-text="
                      item.archive == 1
                        ? 'Desarquivar Documento'
                        : 'Arquivar Documento'
                    "
                    open-class="btn-delete m-1 flex-fill"
                    open-left-icon="fas fa-file mr-1"
                    @yes="updateArchive(item.id)"
                  />
                </template>

                <template v-slot:[`item.required_read`]="{ item }">
                  <v-btn
                    v-if="item.required_read"
                    class="doc-btn"
                    small
                    @click="handleViewedBy(item.id)"
                  >
                    <i class="fas fa-user mr-1"></i>
                    Visualizado Por:
                  </v-btn>

                  <v-btn v-if="!item.required_read" class="doc-btn" small>
                    <i class="fas fa-user mr-1"></i>
                    Vusualizações Liberadas
                  </v-btn>
                </template>

                <template v-slot:[`item.url`]="{ item }">
                  <v-btn
                    v-if="item.url"
                    class="doc-btn"
                    small
                    @click="openDoc(item.url)"
                    target="_blank"
                  >
                    <i class="fas fa-file-alt mr-1"></i>
                    Ver Documento
                  </v-btn>

                  <span v-else class="text-muted">Indisponível</span>

                  <confirmation-dialog
                    small
                    messageTitle=""
                    message-body="Tem certeza que deseja excluir o documento?"
                    open-text="Excluir"
                    open-class="btn-delete m-1 flex-fill"
                    open-left-icon="fa-trash mr-1"
                    @yes="deleteDoc(item.id)"
                  />
                </template>
              </v-data-table>
            </b-overlay>
          </div>
        </div>
      </div>

      <AddDocs
        :folder_id="Number(folder_id)"
        :type_folder="folder.type_folder"
        :resident_id="Number(folder.resident_id)"
        @create="handleAddDocs()"
      />

      <ViewedBy :doc_id="Number(doc_id)" />
    </div>
  </div>
</template>

<script>
import AddDocs from "../templates/DocsFolder/AddDocs";

import ViewedBy from "../templates/DocsFolder/ViewedBy";

import NavBar from "../templates/NavBar";

import ConfirmationDialog from "../templates/Components/ConfirmationDialog";

import ErrorsMessages from "../templates/Components/ErrorsMessages";

import routes from "../routes";

import api from "../services/api";

import toast from "../lib/ToastNotification";

export default {
  name: "DocsFolder",

  components: {
    NavBar,
    AddDocs,
    ViewedBy,
    ErrorsMessages,
    ConfirmationDialog,
  },

  data() {
    return {
      filterArchivedDocs: 0,

      filterRequiredRead: 0,

      loading: false,

      doc_id: false,

      folder_id: false,

      docs: [],

      folder: [],

      errors: [],

      headers: [
        {
          text: "Arquivado",
          value: "archives",
        },
        {
          text: "Cadastrado por",
          value: "user_name",
          class: "col-narrow",
        },
        {
          text: "Tipo Documento",
          value: "type_doc",
          class: "col-narrow",
        },
        {
          text: "Nome",
          value: "name",
          class: "col-narrow",
        },
        {
          text: "Gerenciar Documentos",
          value: "archive",
        },
        {
          text: "Visualização dos Usuários",
          value: "required_read",
        },
        {
          text: "Ações",
          value: "url",
        },
      ],
    };
  },

  async mounted() {
    this.folder_id = this.$route.params.id;

    await this.getDocs();

    await this.getFolder();
  },

  methods: {
    async getDocs() {
      try {
        this.loading = true;

        const { folder_id, filterRequiredRead, filterArchivedDocs } = this;

        let params = {
          rest_home_folder_id: folder_id,
          filterRequiredRead,
          filterArchivedDocs,
        };

        const response = await api.get("/folder/doc", {
          params,
        });

        const { docs } = response.data;

        this.docs = docs;

        this.loading = false;
      } catch (error) {
        this.loading = false;

        console.log(error);
      }
    },

    async getFolder() {
      try {
        this.loading = true;

        const { folder_id } = this;

        const response = await api.get("/folder", {
          params: { id: folder_id },
        });

        const { folder, error, errors } = response.data;

        if (!error) {
          this.folder = folder;

          this.errors = [];
        } else {
          this.errors = errors;
        }

        this.loading = false;
      } catch (error) {
        this.loading = false;

        console.log(error);
      }
    },

    async deleteDoc(id) {
      try {
        this.loading = true;

        let data = { id };

        const response = await api.delete("/folder/doc", {
          data,
        });

        const { error, message } = response.data;

        if (!error) {
          toast(message, "success");

          this.getDocs();
        } else {
          toast(message, "error");
        }

        this.loading = false;
      } catch (error) {
        this.loading = false;

        console.log(error);
      }
    },

    async updateArchive(id) {
      try {
        this.loading = true;

        let params = { id };

        const response = await api.put("/folder/doc", params);

        const { error, message } = response.data;

        if (!error) {
          toast(message, "success");

          this.getDocs();
        } else {
          toast(message, "error");
        }

        this.loading = false;
      } catch (error) {
        this.loading = false;

        console.log(error);
      }
    },

    handleViewedBy(doc_id) {
      this.doc_id = doc_id;

      this.$bvModal.show("viewed_id");
    },

    handleAddDocs() {
      this.getDocs();

      this.$bvModal.hide("createDoc");
    },

    openDoc(url) {
      window.open(url, "_blank");
    },

    handleToBack: () => routes.go(-1),
  },
};
</script>

<style scoped>
.table-section {
  margin-bottom: 32px;
}

.table-card {
  background: white;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.2);
  overflow: hidden;
}

.table-section,
.table-card {
  width: 100%;
}

.loading-overlay {
  border-radius: 16px;
}

.modern-table >>> th.col-narrow,
.modern-table >>> td.col-narrow {
  width: 100px !important;
}

/* Filters Section */
.filters-section {
  margin-bottom: 32px;
}

.filters-card {
  display: flex;
  flex-direction: row;
  gap: 24px; /* Espaço entre os filtros */
  background: white;
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.filter-group {
  flex: 1 1 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-width: 300px;
}

.filter-label {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 600;
  color: #374151;
  margin-bottom: 4px;
}

.filter-icon {
  color: #6b7280;
  font-size: 14px;
}

/* Table Cell Styling */
.user-cell {
  display: flex;
  align-items: center;
  gap: 12px;
}

.user-avatar {
  width: 32px;
  height: 32px;
  background: linear-gradient(135deg, #0f65b0 0%, #1e40af 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 12px;
}

.user-photo {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50%;
  transition: transform 0.2s ease;
}

.user-name {
  font-weight: 500;
  color: #1e293b;
}

.date-cell {
  display: flex;
  align-items: center;
}

.date-badge {
  display: inline-flex;
  align-items: center;
  padding: 3px 6px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.start-badge {
  background: linear-gradient(135deg, #d1fae5 0%, #a7f3d0 100%);
  color: #059669;
  border: 1px solid #34d399;
}

.status-badge {
  display: inline-flex;
  align-items: center;
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.status-active {
  background: linear-gradient(135deg, #d1fae5 0%, #a7f3d0 100%);
  color: #059669;
  border: 1px solid #34d399;
}

.status-inactive {
  background: linear-gradient(135deg, #fee2e2 0%, #fecaca 100%);
  color: #dc2626;
  border: 1px solid #f87171;
}

.note-cell {
  display: flex;
  align-items: center;
  justify-content: center;
}

.note-btn {
  background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%) !important;
  color: white !important;
  border: none !important;
  border-radius: 8px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  font-size: 11px !important;
  box-shadow: 0 2px 8px rgba(245, 158, 11, 0.3) !important;
  transition: all 0.3s ease !important;
}

.note-btn:hover {
  transform: translateY(-1px) !important;
  box-shadow: 0 4px 12px rgba(245, 158, 11, 0.4) !important;
}

.no-note {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  color: #9ca3af;
  font-style: italic;
}

/* Table Styling Override */
.modern-table {
  background: transparent !important;
}

/* Deep selector for Vuetify data table */
.modern-table >>> .v-data-table__wrapper {
  border-radius: 0 !important;
}

.modern-table >>> .v-data-table thead th {
  background-color: #f8fafc !important;
  color: #374151 !important;
  font-weight: 600 !important;
  font-size: 12px !important;
  text-transform: uppercase !important;
  letter-spacing: 0.5px !important;
  border-bottom: 2px solid #e5e7eb !important;
  padding: 16px 12px !important;
}

.modern-table >>> .v-data-table tbody tr:hover {
  background-color: #f8fafc !important;
}

.modern-table >>> .v-data-table tbody td {
  padding: 16px 12px !important;
  border-bottom: 1px solid #f1f5f9 !important;
}

/* Documento botão estilização */
.doc-btn {
  background: linear-gradient(135deg, #0f65b0 0%, #1e40af 100%) !important;
  color: white !important;
  border: none !important;
  border-radius: 8px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  font-size: 11px !important;
  box-shadow: 0 2px 8px rgba(15, 101, 176, 0.3) !important;
  transition: all 0.3s ease !important;
}

.doc-btn:hover {
  transform: translateY(-1px) !important;
  box-shadow: 0 4px 12px rgba(15, 101, 176, 0.4) !important;
}

/* Extra: Nome do documento, tipo e tamanho (ajuste opcional) */
.doc-name {
  font-weight: 500;
  color: #1e293b;
  word-break: break-word;
}

.doc-type,
.doc-size {
  font-size: 13px;
  color: #64748b;
  font-weight: 500;
}

.doc-container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 24px;
}

.doc-header {
  padding: 24px 0;
  background: white;
  border-radius: 0 0 24px 24px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  margin-bottom: 32px;
}

.header-content {
  display: grid;
  grid-template-columns: auto 1fr auto;
  align-items: center;
  gap: 24px;
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 24px;
}

.page-title {
  font-size: 32px;
  font-weight: 700;
  color: #1e293b;
  margin: 0;
  display: flex;
  align-items: center;
}

.title-icon {
  color: #0f65b0;
  margin-right: 12px;
}

.btn-add-modern {
  background: linear-gradient(135deg, #4e9130 0%, #1e884d 100%) !important;
  color: white !important;
  border: none !important;
  border-radius: 12px !important;
  padding: 12px 24px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  box-shadow: 0 4px 15px rgba(78, 145, 48, 0.3) !important;
  transition: all 0.3s ease !important;
}

.btn-add-modern:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 6px 20px rgba(78, 145, 48, 0.4) !important;
}

.btn-add-modern:active {
  transform: translateY(0) !important;
}

.container-modern {
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(30, 41, 59, 0.06);
  padding: 5px 24px 1px 15px;
  margin: 25px 0;
  width: 100%;
  display: flex;
  gap: 25px;
}
</style>